import React from 'react';
import { BlockInfo } from '../../containers/Blocks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const Plan = ({ plan, playVideo, amrp, changeParentImage, isViewNotes, planNotes }) => {
  if (!plan) {
    console.warn("No plan found");
    return null;
  }
  changeParentImage && changeParentImage(plan);
  const subtitle = Object.keys(plan).map((field, k) => {
    const key = `${field}-${k}`;
    const { repsToFailure, pyramidReps, unit, qty, rest, rounds, tempo } = plan;
    switch (field) {
      case 'repsToFailure':
        return !!repsToFailure && <span key={key}>{`reps to failure | `}</span>;
      case 'unit':
        if (pyramidReps && !repsToFailure) {
          let reps = '';
          let value = '';
          if (typeof pyramidReps === 'string') {
            reps = pyramidReps.split(',');
            value = reps.map(r => `(${r}) `).join(' ');
          } else if (Array.isArray(pyramidReps)) {
            reps = pyramidReps.filter(r => r);
            value = reps.map(r => `(${r}) `).toString();
          }
          if (value) return <span key={key}>{`pyramid ${unit} ${value} | `}</span>;
          else if (!!qty) return <span key={key}>{`${qty} ${unit} | `}</span>;
          return null;
        } else {
          return (
            !repsToFailure && !!qty && <span key={key}>{`${qty} ${unit} | `}</span>
          )
        }
      case 'sets':
        if (!plan.circuitId) {
          return (
            <span key={key}>{`${plan[field]} X `}</span>
          )
        }
        break;
      case 'eachSide':
        if (plan[field]) {
          return (
            <span key={key}>{`each side | `}</span>
          )
        }
        break;
      case 'rm':
        if (plan[field]) {
          return (
            <span key={key}>{`${plan[field]}% 1RM | `}</span>
          )
        }
        break;
      case 'wp':
        if (plan[field]) {
          return (
            <span key={key}>{`${plan[field]} lbs. | `}</span>
          )
        }
        break;
      case 'rpe':
        if (plan[field]) {
          return (
            <span key={key}>{`${plan[field]} RPE | `}</span>
          )
        }
        break;
      case 'tempo':
        if (tempo) {
          let data = '';
          let value = '';
          if (typeof tempo === 'string') {
            data = tempo.split(',');
            value = data.map(t => `(${t})`).join(' ');
          } else {
            data = tempo.filter(r => r);
            value = data.map(r => `(${r}) `).toString();
          }
          if (value) return <span key={key}>{`${field} ${value} | `}</span>;
        }
        break;
      case 'rest':
        const restLabel = rest === null ? 'rest as needed' : `${rest} sec. rest`;
        return (
          <span key={key}>{restLabel}</span>
        )
      case 'amrp':
        if (plan['amrp']) {
          return (
            <span key={key}>{"As Many Rounds As Possible;"}</span>
          )
        }
        break;
      case 'rounds':
        if (plan['rounds']) {
          return (
            <span key={key}>{`${rounds} rounds;`}</span>
          )
        }
        break;
      default:
        break;
    }
    return null;
  });

  let filterPlanNotes = [];
  let filterPlanNote;
  filterPlanNotes = planNotes && planNotes.filter((planNote) => {
      return planNote.planId === plan._id
  })
  if (isViewNotes && filterPlanNotes.length > 0) {
    filterPlanNote = filterPlanNotes[0]['note'];
  }

  return (
    <div
      style={{
        padding: '5px 20px',
        borderBottom: '1px solid ' + COLORS.greyFour
      }}
      key={plan.id}
      onClick={() => !isViewNotes && playVideo(plan.exercise[0])}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between'
      }}>
        <div style={{ width: '80%' }}>
          <div style={{
            fontWeight: 'bold',
            color: COLORS.black
          }}>
            {plan.exercise[0].name}
          </div>
          <div style={{
            color: COLORS.greyTwo
          }}>
            {!isViewNotes && subtitle}
            {isViewNotes && filterPlanNote}
          </div>
        </div>
        <div style={{
          width: '20%',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          flexDirection: 'column'
        }}>
        {!isViewNotes &&
          <FontAwesomeIcon
            className="link"
            icon={['far', 'play-circle']}
            style={{
              color: COLORS.greyTwo,
              fontSize: 20
            }}
          />
        }
        </div>

      </div>

    </div>
  );
}

const Circuit = ({ circuit, playVideo, blockOrder, changeParentImage, planNotes, isViewNotes }) => {
  const plansContent = circuit.plans.map((plan, index) => {
    return (<Plan changeParentImage={changeParentImage}
      planNotes = {planNotes}
      isViewNotes = {isViewNotes}
      playVideo={(exercise) => playVideo(exercise)} key={index} plan={plan} amrp={circuit.amrp} />);
  });
  const titleContainer = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    background: COLORS.greyThree,
    height: 30,
    color: COLORS.white,
    marginBottom: 5,
    fontSize: 'small'
  }
  let rounds = circuit.amrp ? 
            `Circuit - As Many Rounds as Possible in ${circuit.amrp} min` : 
            circuit.emom ? `Circuit - EMOM ${circuit.emom} Rounds` : 
            `Circuit - ${circuit.rounds} Rounds`
  return (
    <div>
      <div style={titleContainer}>
        {rounds}
      </div>
      {plansContent}
      <div style={titleContainer}>
        End Circuit Round
      </div>
    </div>
  );
}
class SequenceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoToggle: false,
      currExercise: '',
    };
  };
  playVideo(exercise) {
    this.setState({ videoToggle: true, currExercise: exercise });
  }
  mappedSequences() {
    const { sequences, plans, circuits } = this.props;
    const getPlan = (planId, circuitId) => {
      let plan
      if (circuitId) {
        plan = Object.values(plans).filter((plan) => (Number(plan.planId) === Number(planId) && Number(plan.circuitId) === Number(circuitId)))[0];
      } else {
        plan = Object.values(plans).filter((plan) => (Number(plan.planId) === Number(planId) && plan.circuitId === undefined))[0];
      }
      return plan;
    }
    const getCircuit = (circuitId) => {
      let circuit = Object.values(circuits).filter((circuit) => Number(circuit.circuitId) === Number(circuitId))[0];
      const planIds = (typeof circuit.planIds === 'string') ? circuit.planIds.split(',') : circuit.planIds;
      circuit.plans = planIds.map((planId) => {
        return getPlan(planId, circuitId);
      })
      return circuit;
    }
    return sequences.map((seq, index) => {
      switch (seq.child) {
        case 'plan':
          seq.plan = getPlan(seq.childId);
          break;
        case 'circuit':
          seq.circuit = getCircuit(seq.childId);
          break;
        default:

      }

      return seq;
    });
  }
  render() {
    //render ALL plans with workout ID into keyed array
    //render ALL circuits with workout ID
    //rener ALL sequences with workout ID
    const { currExercise, videoToggle } = this.state;

    const content = this.mappedSequences().map((seq, index) => {

      switch (seq.child) {

        case 'plan':
          return (<Plan changeParentImage={this.props.changeParentImage}
            planNotes = {this.props.planNotes}
            isViewNotes = {this.props.isViewNotes}
            playVideo={(url) => this.playVideo(url)} key={index} plan={seq.plan} />);
        case 'circuit':
          return (<Circuit changeParentImage={this.props.changeParentImage}
            planNotes = {this.props.planNotes}
            isViewNotes = {this.props.isViewNotes}
            blockOrder={seq.orderId} playVideo={(url) => this.playVideo(url)}
            key={index} circuit={seq.circuit} />);
        case 'block':
          return (
            <BlockInfo
              blockId={seq.childId}
              changeParentImage={this.props.changeParentImage}
              title={false}
              key={index}
            />
          )
        default:
          return null;
      }
    });
    return (
      <div style={{ width: '100%' }}>
        <Dialog onClose={() => this.setState({ videoToggle: false })} aria-labelledby="customized-dialog-title" open={videoToggle}>
          <DialogTitle id="customized-dialog-title" onClose={() => this.setState({ videoToggle: false })}>
            Preview
        </DialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              <div className="modalBody modal-content" style={{ width: 320 }}>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%'
                  }}>
                    <video controls src={currExercise.videoUrl} autoPlay loop muted style={{ width: '100%' }} />
                  </div>
                  <div style={{
                    backgroundColor: COLORS.greyFour,
                    padding: 10,
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}>
                      <div style={{
                        width: 'fit-content',
                        background: COLORS.greyThree,
                        borderRadius: 2,
                        padding: '3px 5px',
                        color: COLORS.greyFour
                      }}>
                        Category
								</div>
                      <div style={{
                        fontWeight: 'bold'
                      }}>
                        {currExercise.name}
                      </div>
                      <div style={{
                        fontWeight: 'bold',
                        marginTop: 10
                      }}>
                        Description
								</div>
                      <div style={{ textAlign: 'left', wordBreak: 'break-word' }}>
                        {currExercise.description}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Typography>
          </DialogContent>

        </Dialog>


        {
          content
        }

      </div>
    );
  }
}

export default SequenceList;



// WEBPACK FOOTER //
// ./src/components/workouts/SequenceList.js